module.exports = __webpack_public_path__ + "img/introduce.205753af.webp";